import { Validators } from '@angular/forms';

export class QuoteResultsModel {
  monthlyRepayments = {
    value: null,
    validation: Validators.compose([])
  };

  totalRepayments = {
    value: null,
    validation: Validators.compose([])
  };

  expiration = {
    value: null,
    validation: Validators.compose([])
  };

  netMonthlyRepayments = {
    value: null,
    validation: Validators.compose([])
  };

  gst = {
    value: null,
    validation: Validators.compose([])
  };

  totalInterest = {
    value: null,
    validation: Validators.compose([])
  };
}
